import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType, URLSearchParams } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';
import { OpcionesPago } from './tools/helpers.service';

@Injectable()
export class PagosService {

  private service_url : string = '';
  private calcService_url : string = '';
  private recibo_url : string = '';

  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService, 
      private validatorService: ValidatorService, 
      private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/pagos';
    this.calcService_url = this.constantsService.apiURL + '/calculo';
    this.recibo_url = this.constantsService.apiURL + '/recibos/pago';
  }

  /**
   * 
   * @param id: CreditosId
   * @param idPago: Para la edición de un pago.Se debe enviar el id del pago para obtener las opciones de pago 
   * sin considerar el monto del pago realizado 
   * @param porcentaje_descuento: Calcula las opciones de pago aplicando un descuento
   */
  public getOpcionesPago(id: number, idPago: number, porcentaje_descuento: number = null) {

    let myParams = new URLSearchParams();

    if(idPago){
      myParams.append('idPagos', idPago.toString());
    }

    if(porcentaje_descuento){
      myParams.append('descuento', porcentaje_descuento.toString());
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;

    let urlService = this.calcService_url + '/opcionesPagos/' + id;
    
    return this.http.get(urlService , myoptions);
  }

  public getTablaPagos(id: number) {
    return this.http.get(this.calcService_url + '/tablaPagos/' + id, this.authService.getAuthHeaders());
  }

  public getPago(id: number) {
    return this.http.get(this.service_url + '/' + id, this.authService.getAuthHeaders());
  }

  public getReciboPago(id: number, url : string) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(this.recibo_url + '/' + id +"?url="+ url + '?action=download' , options);
  }

  public save(pago : object) {
    return this.http.post(this.service_url , pago, this.authService.getAuthHeaders());
  }

  public update( credito : object) {
    return this.http.put(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public validate(pago: any){
    let error = [];

    if(!this.validatorService.required(pago.tipo) || !this.validatorService.numeric(pago.monto_pago)){
        error["tipo"] = this.errorService.required;
    }

    if(!this.validatorService.required(pago.forma)){
        error["forma"] = this.errorService.required;
    }

    if(!this.validatorService.required(pago.fecha)){
        error["fecha"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(pago.penalizacion)){
      error["penalizacion"] = this.errorService.required;
    }

    if(pago.abono && +pago.abono > 0){
      //Si se ingreso un monto de abono se debe seleccionar el tipo de abono
      if(!this.validatorService.required(pago.tipo_abono)){
          error["tipo_abono"] = this.errorService.required;
      }
    }

    if(pago.tipo_abono){
      //Si se selecciono un tipo de abono se debe ingresar el monto del abono
      if(!this.validatorService.required(pago.abono)){
          error["abono"] = this.errorService.required;
      }
    }

    if(pago.porcentaje_descuento && pago.porcentaje_descuento > 100){
      //El descuento no puede ser mayor al 100%
      error["porcentaje_descuento"] = "El descuento no puede ser mayor al 100%";
    }

    return error;
  }

  public validateDistribucion(pago: any){
    let error = [];

    if(pago.tipo === OpcionesPago.Periodo && !this.validatorService.required(pago.litros_consumidos)){
      error["litros_consumidos"] = this.errorService.required;
    }

    if(!this.validatorService.required(pago.forma)){
        error["forma"] = this.errorService.required;
    }

    if(!this.validatorService.required(pago.fecha)){
        error["fecha"] = this.errorService.required;
    }

    if(!this.validatorService.numeric(pago.penalizacion)){
      error["penalizacion"] = this.errorService.required;
    }

    if(pago.porcentaje_descuento && pago.porcentaje_descuento > 100){
      //El descuento no puede ser mayor al 100%
      error["porcentaje_descuento"] = "El descuento no puede ser mayor al 100%";
    }
    
    return error;
  }

  public getPagosPendientesDelConvenio(filters: any) {
    let myParams = new URLSearchParams();

    if(filters.idConvenios){
      myParams.append('idConvenios', filters.idConvenios);
    }

    if(filters.fecha_fin){
      myParams.append('fecha_fin', filters.fecha_fin);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;

    let serviceUrl = `${this.service_url}/convenios/pagos-pendientes`
    
    return this.http.get(serviceUrl , myoptions);
  }

  public makePayments(paymentsToDo : any) {
    let serviceUrl = `${this.service_url}/convenios/pagar`
    return this.http.post(serviceUrl , paymentsToDo, this.authService.getAuthHeaders());
  }

}


// WEBPACK FOOTER //
// ./src/app/services/pagos.service.ts